module.exports = __webpack_public_path__ + "static/l4u-495e39223441a3115663aa9410b51efe.jpeg";